import { Button, Col, DatePicker, Form, message, Row, Select } from "antd";
import { useEffect, useState } from "react";
import ReportService from "../../../services/ReportService";
import ResponseMessage from "../../Comman/Notification/ResponseMessge";

const GenerateReport = ({ handleGetEolReport, handleGetDate }) => {
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [itemOptions, setItemOptions] = useState([]);
    const [poOptions, setPoOptions] = useState([]);
    const [colorOptions, setColorOptions] = useState([]);
    const [afterDateSelect, setAfterDateSelect] = useState([]);

    const [selectedItem, setSelectedItem] = useState();
    const [selectedPoNo, setSelectedPoNo] = useState();
    const [selectedColor, setSelectedColor] = useState();
    const [eol_data, setEolData] = useState([]);
    const [form] = Form.useForm();

    useEffect(() => {
        const fetchItems = async () => {
            try {
                const response = await ReportService.getItem();

                if (response?.error) {
                    ResponseMessage.error(response.message || "An error occurred.");
                    return;
                }

                if (response?.item_nos) {
                    const uniqueItems = Array.from(new Set(response.item_nos));
                    const options = uniqueItems.map(item => ({
                        label: item,
                        value: item,
                    }));
                    setItemOptions(options);
                } else {
                    console.error("No 'Item' field in response");
                    ResponseMessage.error("No 'Item' field in response");
                }
            } catch (error) {
                console.error("Error fetching items:", error);
                ResponseMessage.error("Failed to fetch items.");
            }
        };

        fetchItems();
    }, []);

    const handleDateChange = (dateRange) => {
        if (!dateRange || !Array.isArray(dateRange)) {
            console.error("Invalid date range:", dateRange);
            setStartDate(null);
            setEndDate(null);
            return;
        }
    
        const [start_Date, end_Date] = dateRange;
    
        if (start_Date && end_Date) {
            setStartDate(start_Date.format("YYYY-MM-DD"));
            setEndDate(end_Date.format("YYYY-MM-DD"));
        } else {
            console.error("Invalid date range values:", dateRange);
            setStartDate(null);
            setEndDate(null);
        }
    };
    

    const handleItemChange = async (value) => {
        setSelectedItem(value);

        try {
            const response = await ReportService.getPObyItem(value);

            console.log("Response from getPObyItem:", response);

            if (!response?.data?.length) {
                ResponseMessage.info(response?.message || "No PO numbers available.");
                setPoOptions([]);
                return;
            }

            const options = Array.from(
                new Set(response.data.map((po) => po.po_no))).map((uniquePoNo) => ({
                    label: uniquePoNo, // Use the unique po_no as the label
                    value: uniquePoNo, // Use the unique po_no as the value
                }));

            setPoOptions(options);
        } catch (error) {
            console.error("Error during getPObyItem call:", error);
            ResponseMessage.error("Failed to fetch PO numbers.");
        }
    };


    const handlePOChange = async (value) => {
        setSelectedPoNo(value);

        try {
            const response = await ReportService.getColorByPO(value);

            if (!response?.data?.length) {
                ResponseMessage.info("No colors available for the selected PO.");
                setColorOptions([]);
                return;
            }

            const options = response.data.map(color => ({
                label: color.color,
                value: color.set_id,
            }));
            setColorOptions(options);
        } catch (error) {
            console.error("Error fetching colors:", error);
            ResponseMessage.error("Failed to fetch colors.");
        }
    };

    const handleColorChange =(value) => {
        setSelectedColor(value);
    };

    const handleGetResult = async()=>{
        console.log(startDate, endDate, selectedPoNo, selectedItem, selectedColor);
        try {
            const response = await ReportService.getEolReport(startDate, endDate, selectedPoNo, selectedItem, selectedColor);
            setEolData(response.data);
            handleGetEolReport(response.data);
            handleGetDate(startDate, endDate);
            ResponseMessage.info(response.message); 
            
        } catch (error) {
            console.error(error);
            ResponseMessage.error(error);
            setEolData([]); // Clear eol_data on error
        }
    };

    const handleClear=()=>{
        console.log("clear");
        form.resetFields();
        setStartDate(null);
        setEndDate(null);
        setSelectedPoNo(null);
        setSelectedItem(null);
        setSelectedColor(null);
        setEolData([]);
        handleGetEolReport([]);
    };

    return (
        <Form layout="vertical" form={form}>
            <Row gutter={[16, 16]} wrap={false} align="middle">
            
            {/* Date Range Picker */}
            <Col flex="auto">
                <Form.Item label={<strong>Select Date Range</strong>} name='dateRange'>
                <DatePicker.RangePicker onChange={handleDateChange}  
                style={{ width: "100%" }}/>
                </Form.Item>
            </Col>
        
            {/* Item Dropdown */}
            <Col flex="auto">
                <Form.Item label={<strong>Item</strong>} name='item'>
                <Select
                    showSearch
                    placeholder="Select an Item"
                    options={itemOptions}
                    onChange={handleItemChange}
                    value={selectedItem}
                    style={{ width: "100%" }}
                />
                </Form.Item>
            </Col>
        
            {/* PO Dropdown */}
            <Col flex="auto">
                <Form.Item label={<strong>PO No.</strong>} name='poNo'>
                <Select
                    showSearch
                    placeholder="Select a PO No."
                    options={poOptions}
                    onChange={handlePOChange}
                    value={selectedPoNo}
                    style={{ width: "100%" }} 
                />
                </Form.Item>
            </Col>
        
            {/* Color Dropdown */}
            <Col flex="auto">
                <Form.Item label={<strong>Color</strong>} name='color'>
                <Select
                    showSearch
                    placeholder="Select a Color"
                    options={colorOptions}
                    onChange={handleColorChange}
                    value={selectedColor}
                    style={{ width: "100%" }}
                />
                </Form.Item>
            </Col>
        
            {/* Get Result Button */}
            <Col>
                <Form.Item label='  '>
                <Button type="primary" onClick={handleGetResult}>
                    Get Result
                </Button>
                </Form.Item>
            </Col>
        
            {/* Clear Button */}
            <Col>
                <Form.Item label='  '>
                <Button danger onClick={handleClear}>
                    Clear
                </Button>
                </Form.Item>
            </Col>
        
            </Row>
      </Form>      
      
    );
};

export default GenerateReport;